import axios from 'axios'
import i18n from '@/plugins/i18n/index'

// getTime() / 1000 = Timestamp in Seconds
// To get the unix timestamp we need to add/subtract the timezone offset in seconds.
// getTimezoneOffset() is the offset in minutes. So we need to multiply it by 60 to get the seconds.
const currentYear = new Date().getFullYear()
const nextYear = currentYear + 1
const lastYear = currentYear - 1
const currentYearEndDate = new Date(`${nextYear}`)
const currentYearEndTimestamp = (currentYearEndDate.getTime() / 1000) + (currentYearEndDate.getTimezoneOffset() * 60)
const currentYearStartDate = new Date(`${currentYear}`)
const currentYearStartTimestamp = (currentYearStartDate.getTime() / 1000) + (currentYearStartDate.getTimezoneOffset() * 60)
const lastYearEndTimestamp = currentYearStartTimestamp
const lastYearStartDate = new Date(`${lastYear}`)
const lastYearStartTimestamp = (lastYearStartDate.getTime() / 1000) + (lastYearStartDate.getTimezoneOffset() * 60)

const state = () => ({
  loaded: false,
  items: [],
  currentPage: 1,
  itemsPerPage: 9,
  numberOfPages: 1,
  numberOfTotalItems: 9,
  availableYears: [
    { uid: null, name: i18n.t('filter.year.options.all') },
    { uid: 1, name: `${currentYear}`, lte: currentYearEndTimestamp, gte: currentYearStartTimestamp },
    { uid: 2, name: `${lastYear}`, lte: lastYearEndTimestamp, gte: lastYearStartTimestamp },
    { uid: 3, name: i18n.t('filter.year.options.archive'), lte: lastYearStartTimestamp, gte: null }
  ],
  selectedYear: null
})

const getters = {
  getParams: (state, getters, rootState) => {
    const params = {
      currentPage: state.currentPage,
      itemsPerPage: state.itemsPerPage
    }
    if (rootState.industries.selected.length) {
      params['industries[contains]'] = rootState.industries.selected.toString()
    }
    if (rootState.categories.selected.length) {
      params['categories[contains]'] = rootState.categories.selected.toString()
    }
    if (state.selectedYear !== null) {
      const year = state.availableYears[state.selectedYear]
      params['date[lessThanOrEqual]'] = year.lte
      if (year.gte) {
        params['date[greaterThanOrEqual]'] = year.gte
      }
    }
    if (rootState.pidConstraint !== '') {
      params.pid = rootState.pidConstraint
    }
    return params
  }
}

const mutations = {
  setLoaded (state, payload) {
    state.loaded = payload
  },
  setItems (state, payload) {
    state.items = [...payload]
  },
  addItems (state, payload) {
    state.items = [...state.items, ...payload]
  },
  resetCurrentPage (state) {
    state.currentPage = 1
  },
  increaseCurrentPage (state) {
    state.currentPage += 1
  },
  setNumberOfPages (state, payload) {
    state.numberOfPages = payload
  },
  setNumberOfTotalItems (state, payload) {
    state.numberOfTotalItems = payload
  },
  setAvailableYears (state, payload) {
    state.availableYears = payload
  },
  setSelectedYear (state, payload) {
    state.selectedYear = payload
  }
}

const actions = {
  async get ({ state, commit, getters }) {
    commit('setLoaded', false)
    try {
      const response = await axios.get(window.app.news_list.api_base + 'news/', { params: { ...getters.getParams } })
      state.currentPage === 1
        ? commit('setItems', response.data.news)
        : commit('addItems', response.data.news)
      commit('setNumberOfPages', response.data.numberOfPages)
      commit('setNumberOfTotalItems', response.data.numberOfTotalItems)
      commit('setLoaded', true)
      return response
    } catch (e) {
      commit('setErrors', e, { root: true })
    }
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
